import { connect } from "react-redux";
import { useThemeSwitcher } from "react-css-theme-switcher";

type Props = {
  selectedEnv: string;
  children: React.ReactNode;
};

const EnvColorTheme = (props: Props) => {
    const { currentTheme } = useThemeSwitcher();

    const themes: {[key: string]: string} = {
        'prod': '#3e79f7',
        'stage': '#ffc542',
        'sand': '#21B573',
        'hover_prod': '#699dff',
        'hover_stage': '#ffd46f',
        'hover_sand': '#41ca8c'
    };
    const headerThemes: {[key: string]: string} = {
        'dark_prod': '#283142',
        'dark_stage': '#7a5c15',
        'dark_sand': '#326d32',
        'light_prod': '#ffffff',
        'light_stage': '#e4b23c',
        'light_sand': '#6ee06e',
    };

    return (
        <div
            style={
                {
                    '--server-color': themes[props.selectedEnv],
                    '--server-color-hover': themes[`hover_${props.selectedEnv}`],
                    '--dark-header-bg-color': headerThemes[`${currentTheme}_${props.selectedEnv}`],
                    '--light-header-bg-color': headerThemes[`${currentTheme}_${props.selectedEnv}`],
                } as React.CSSProperties }
            >
            {props.children}
        </div>
    )
}

const mapStateToProps = ({ game }: any) => {
  const { selectedEnv } = game;
  return { selectedEnv };
};

export default connect(mapStateToProps)(EnvColorTheme);